import Service from './Service'

class SystemService extends Service {
    getDataIntegrityWarnings() {
        return Service.dataIntegrity
    }
}
const instance = new SystemService()
export default instance
